module.exports = __webpack_public_path__ + "static/category-tshirt-dad39991f203fdae237f2161525424be.jpg";